import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames';
import { LinkedWrapperProps } from 'atomic/linked-wrapper/linked-wrapper.interface';

import './linked-wrapper.scss';

const LinkedWrapper: FC<LinkedWrapperProps> = ({ title, children, href, className }) => {
    const onLink = (event: MouseEvent<HTMLElement>): void => {
        const clickedElement = event.target as HTMLElement;

        if (clickedElement.nodeName.toLowerCase() !== 'a') {
            window.location.href = href;
        }
    };

    return (
        <div
            title={title}
            className={classNames('linked-wrapper', className)}
            onClick={onLink}
        >
            {children}
        </div>
    );
};

export default LinkedWrapper;
